import React from "react";
import { Alert, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

/** Usuário master entrou no console, mas nenhuma seção tem `view`. */
export default function PlatformConsoleNoAccess() {
  const { t } = useTranslation("app");
  return (
    <Box sx={{ py: 2 }}>
      <Alert severity="warning">
        {t("platformPage.consoleNoSectionAccess", {
          defaultValue:
            "Sua conta não tem permissão para nenhuma área do console da plataforma. Peça a um administrador para ajustar o acesso em Governança.",
        })}
      </Alert>
    </Box>
  );
}
